// extracted by mini-css-extract-plugin
export var fileExt = "_vk-8";
export var fileIcon = "_vk-6";
export var fileLink = "_vk-5";
export var fileName = "_vk-7";
export var image = "_vk-1";
export var imageError = "_vk-3";
export var imageErrorIcon = "_vk-4";
export var imageLink = "_vk-0";
export var imageLoaded = "_vk-2";